<template>

  <div>


    <div style="color: black;margin-top: 10px;margin-left: 10px">


      <a-input style="width: 150px;float:left;" v-model:value="pagination.species" placeholder="species" />
      <a-input style="width: 150px;float:left;margin-left: 40px" v-model:value="pagination.tissues" placeholder="tissues" />
      <a-input style="width: 150px;float:left;margin-left: 40px" v-model:value="pagination.celltype" placeholder="celltype" />
      <a-input style="width: 150px;float:left;margin-left: 40px" v-model:value="pagination.cellmaker" placeholder="cellmaker" />
      <a-button style="float:left;margin-left: 20px" type="primary" :size="size" @click="getall">Search</a-button>
      <a-button style="float:left;margin-left: 20px" type="primary" :size="size" @click="restart">Reset</a-button>


      <a-table
          style="margin-top: 20px;"
          :columns="columns"
          :data-source="dataSource"

      >
      </a-table>


    </div>
  </div>

  <!--  <router-view/>-->
</template>

<script>
import axios from "axios";
export default {
  name: "BrowsePage",
  data(){
    return{
      imgdata:'',
      showcontent:false,
      dataSource: [],
      pagination: {//分页相关模型数据
        currentPage: 1,//当前页码
        pageSize:100000,//每页显示的记录数
        total:0,//总记录数
        species: "",
        tissues: "",
        celltype: "",
        cellmaker:"",

      },
      columns: [
        // 定义表格列
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'Species',
          dataIndex: 'species',
          key: 'species',
        },
        {
          title: 'Tissues',
          dataIndex: 'tissues',
          key: 'tissues',
        },
        {
          title: 'Celltype',
          dataIndex: 'celltype',
          key: 'celltype',
        },
        {
          title: 'Cellmaker',
          dataIndex: 'cellmaker',
          key: 'cellmaker',
        },


      ],
    }
  },
  methods:{
    getall() {
      // var param = "?species="+this.pagination.species;
      // param += "&tissues="+this.pagination.tissues;
      // param += "&celltype="+this.pagination.celltype;
      // param += "&cellmaker="+this.pagination.cellmaker;

      axios.defaults.baseURL = 'https://www.diseaselinks.com:8080';
      axios.post("/gene/"+this.pagination.currentPage+"/"+this.pagination.pageSize,this.pagination).then((res)=>{
        this.dataSource =  Array.from(res.data.data.records);
      })
    },
    restart() {
      this.pagination.species='';
      this.pagination.tissues='';
      this.pagination.celltype='';
      this.pagination.cellmaker='';


      var param = "?species="+this.pagination.species;
      param += "&tissues="+this.pagination.tissues;
      param += "&celltype="+this.pagination.celltype;
      param += "&cellmaker="+this.pagination.cellmaker;

      axios.defaults.baseURL = 'https://www.diseaselinks.com:8080';

      axios.get("/gene/"+this.pagination.currentPage+"/"+this.pagination.pageSize+param).then((res)=>{
        this.dataSource =  Array.from(res.data.data.records);
      })
    },
    getdata() {
      $.ajax({
        'url': 'https://www.diseaselinks.com:8080/Tissue/upload3',
        'type': 'get',
        success: data => {
          console.log(data.newname);
          this.imgdata=data.newname;
        }
      })
    },

  },
  mounted() {
    this.getdata();
    this.getall();
  }
}
</script>

<style scoped>

</style>